import { API_URL } from "../constants";
import * as httpNetworking from "../httpNetworking";

const URL = API_URL + "/saas/aws/regions";
const VERSION = 0;

export type RegionsResponse = {
    regions: string[];
};

export default async function getSupportedRegions(): Promise<RegionsResponse> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 50000
    };
    const response = await httpNetworking.simpleGETRequest(URL, options, VERSION);
    return response.data;
}
